import axios, { AxiosRequestConfig } from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------
import { useSession, signIn, signOut } from "next-auth/react"

// ----------------------------------------------------------------------


const axiosInstance = axios.create({
  baseURL: 'https://justtofeelsomething.io'
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  asin: {
    list: '/dashboard/testing',
  },
  storefront: {
    list: '/storefronts/testing',
    add: '/storefronts/testing/add/',
    remove: '/storefronts/testing/remove/',
    snapshots: (id: string) => `/storefronts/${id}/snapshots`,
  },
  topstores: {
    list: '/tsf',
  },
  filters: {
    list: '/personalization/getFilters',
    update: '/personalization/updateFilters'
  },
  archive: {
    list: '/archive',
    create: '/archive',
    unarchive: '/unarchive',
    bulk: '/archive/bulk',
    bulkUnarchive: '/unarchive/bulk'
  }
};
